<mat-card-header  class="justify-content-center">
  <mat-card-title class="card-title"> {{ info.story_form_title }} </mat-card-title>
</mat-card-header>
<hr class="line">
<mat-card-content class="card-content">
  <form class="form-container" [formGroup]="descForm" (ngSubmit)="submit(descForm.value)" autocomplete="off">
    <app-editor class="editor" [group]="descForm"
                [control]="desc"
                [draftId]="draft?.id"
                [draftData]="draft"
                (focusout)="updateInfoDraft()"
                [info]="info" >
    </app-editor>
    <button id="descSubmitBtn" style="display: none" ></button>

    <div class="info">
      <!-- medical docs and city -->
      <div class="image-heading">
        <span>{{info.medicalDocTitle}}</span>
        <mat-icon (click)="showPopover = true" class="style-as-link" aria-hidden="false" aria-label="Upload Medical Docs Instructions">help</mat-icon>
      </div>
      <div class="image-wrapper">
        <div class="item-img" *ngFor="let item of vars.medicalbill">
          <span class="delete" (click)="openDeleteModal(item?.id)"><i
              class="material-icons" *ngIf="item.status !== 1">remove_circle_outline</i></span>
          <img [src]="item.cdn_path" [alt]="item.detail_1" default="/assets/images/default-img.jpg">
        </div>
        <app-upload-img class="item-img" [selectOptions]="medicalDocs" [displayType]="'medicalbill'" [info]="info"
        (uploadedMedia)="vars.medicalbill.push($event)" label="Upload" medialURL="/docs"></app-upload-img>
      </div>
      <div class="steps-wrapper" *ngIf="info?.skipStepInfo">
        <div class="smiley">😇</div>
        <div class="text">{{info.skipStepInfo}}</div>
      </div>
      <div class="checkbox-wrapper" *ngIf="!showInsuranceCondition">
        <mat-checkbox color="primary" [formControl]="insuranceCondition">
        </mat-checkbox>
        <div class="story-footer">I consent to raising funds for a ₹1.2 lakh insurance cover for a family member of my choice.</div>
      </div>
      <div class="checkbox-wrapper">
        <mat-checkbox color="primary" [formControl]="termsCondition">
        </mat-checkbox>
        <div [ngSwitch]="util.storage.get('language')">
          <div *ngSwitchCase="'Hindi'" class="story-footer">
              मैं केटो की
              <a class="primary-color" target="_blank" [href]="origin + '/terms-of-use.php'" queryParamsHandling="merge">{{ info.terms_of_use}}</a>,
              <a class="primary-color" target="_blank" [href]="origin + '/privacy-policy.php'"  queryParamsHandling="merge">{{ info.privacy_policy}}</a>,
              सेवा अनुबंध (
              <a class="primary-color" target="_blank" href="https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoUSAserviceagreement.pdf" queryParamsHandling="merge"> USA</a>
              और
              <a class="primary-color" target="_blank" [href]="isPersonalCampaign ? 'https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoIndiaServiceagreementForPersonal.pdf':'https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoIndiaserviceagreement.pdf'" queryParamsHandling="merge"> India</a> ),
              <span *ngIf="!isPersonalCampaign">
                और
              </span>
              <a class="primary-color" target="_blank" [href]="origin + '/support/plans-and-pricing.php'"  queryParamsHandling="merge">{{ info.plans_and_pricing}}</a>
              <span *ngIf="isPersonalCampaign">
                और मेडीबुड्डी फ़ायदे
              </span>
              के लिए सहमत हूं।
              {{info.acknowledge}}
          </div>
          <div *ngSwitchCase="'English'" class="story-footer">
            <ng-container *ngTemplateOutlet="defaultCase"></ng-container>
          </div>
          <div class="story-footer" *ngSwitchCase="'Telugu'">
            నేను కెట్టో
            <a class="primary-color" target="_blank" [href]="origin + '/terms-of-use.php'" queryParamsHandling="merge">ఉపయోగ నిబంధనలకి</a>, 
            సేవ ఒప్పంధనానికి (
            <a class="primary-color" target="_blank" href="https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoUSAserviceagreement.pdf" queryParamsHandling="merge"> USA</a>
            {{ info.and }}
            <a class="primary-color" target="_blank" [href]="isPersonalCampaign ? 'https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoIndiaServiceagreementForPersonal.pdf':'https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoIndiaserviceagreement.pdf'" queryParamsHandling="merge"> India</a> ), 
            <a class="primary-color" [href]="origin + '/privacy-policy.php'" queryParamsHandling="merge">
              గోప్యతా పాలసీలకి
            </a>
             
            మరియు 
             
            <a class="primary-color" target="_blank" [href]="origin + '/support/plans-and-pricing.php'"  queryParamsHandling="merge">
              ప్రణాళికలకు & ధరాలకి
            </a> 
            , &
             అంగీకరిస్తున్నాను. 
            పైన ఇచ్చిన సమాచారం
            
            నా జ్ఞానం మరియు నమ్మకానికి సరైనదని నేను గుర్తించాను మరియు ధృవీకరిస్తున్నాను. 
            తప్పు అని తేలితే నేను బాధ్యత వహించాలని అంగీకరిస్తున్నాను. 
            రెగ్యులేటరీ అధికారులతో మరియు చట్టం ప్రకారం అవసరమయ్యే విధంగా తెలియచేయడానికి నేను దీని ద్వారా నా సమ్మతిని ఇస్తున్నాను.
          </div>
          <div *ngSwitchCase="'Tamil'" class="story-footer">
            <ng-container *ngTemplateOutlet="defaultCase"></ng-container>
          </div>
          <div *ngSwitchDefault class="story-footer">
            <ng-container *ngTemplateOutlet="defaultCase"></ng-container>
          </div>
        </div>
      </div>
    </div>
  </form>
</mat-card-content>
<mat-card-footer class="fund-button-container">
  <button mat-raised-button class="fund-button" type="submit" color="primary" (click)="submitButton()" [disabled]="isLoading">
    <div class="button-wrapper" *ngIf="!isLoading" >
      {{ info.submit }}
    </div>
    <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
  </button>
  <!-- <button mat-raised-button class="fund-button" type="submit" color="primary" (click)="submitButton()">SUBMIT FOR APPROVAL</button> -->
</mat-card-footer>

<!-- info modal -->
<ng-template #infoDialog>
  <div class="dialog-container">
    <div class="dialog-header">
      <button (click)="dialog.closeDialog()" mat-icon-button><mat-icon>close</mat-icon></button>
    </div>
    <mat-dialog-content class="infoDialog" [innerHTML]="info.description_story.popover.placeholder">
    </mat-dialog-content>
    <mat-dialog-actions class="btn-container">
      <button mat-button class="dialog-btn back-btn" color="primary" (click)="closeDialog()">
        <mat-icon matPrefix>chevron_left</mat-icon> {{info.back}}
      </button>
      <button mat-button class="dialog-btn assist-btn" color="primary" (click)="getAssist()" cdkFocusInitial>
        {{info.get_assistance}}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>

<!-- success modal -->
<ng-template #successDialog>
  <div class="dialog-container">
    <div class="dialog-header">
      <button (click)="dialog.closeDialog()" mat-icon-button><mat-icon>close</mat-icon></button>
    </div>
    <mat-dialog-content>
      <div class="text-center">
        <img loading="lazy" data-src="/assets/images/done.png" alt="done_image">
        <div class="assist-text">
          We have sent a request to your fundraiser <br> expert.
          We'll get back to you shortly. <br>You can also call us at
          <a class="text-primary" [href]="'tel:91'+ vars.contactUsMobNumber">+91 {{vars.contactUsMobNumber}}</a>
        </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions class="flex-container">
      <button mat-button class="dialog-btn ok-btn" color="primary" (click)="closeDialog()">OK</button>
    </mat-dialog-actions>
  </div>
</ng-template>

<ng-template #defaultCase>
  {{ info.iAgree }}
  <a class="primary-color" target="_blank" [href]="origin + '/terms-of-use.php'" queryParamsHandling="merge"> {{ info.terms_of_use}}</a>,
  {{ info.serviceAgreement }} (
  <a class="primary-color" target="_blank" href="https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoUSAserviceagreement.pdf" queryParamsHandling="merge"> USA</a>
  {{ info.and }}
  <a class="primary-color" 
    target="_blank" 
    [href]="isPersonalCampaign ? 'https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoIndiaServiceagreementForPersonal.pdf'
      :'https://d1vdjc70h9nzd9.cloudfront.net/digital-signature/KettoIndiaserviceagreement.pdf'" queryParamsHandling="merge"> 
      India</a> ),
  <a class="primary-color" target="_blank" [href]="origin + '/privacy-policy.php'"  queryParamsHandling="merge">
    {{ info.privacy_policy}},
  </a> 
  <a class="primary-color" target="_blank" [href]="origin + '/support/plans-and-pricing.php'"  queryParamsHandling="merge"> 
    {{ info.plans_and_pricing}}
  </a> 
  {{info.acknowledge}}
</ng-template>

<app-popover-loader *ngIf="showPopover" [show]="showPopover" [config]="{popupClass: 'input-popover', title: info?.medicalPopoverContent?.title, desc: info?.medicalPopoverContent?.desc, class: 'v4'}" (hideel)="showPopover = $event"></app-popover-loader>